import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar,
  RadioCardOptionGroup,
  ScreenHeader
} from '../../components';

const options = [
  {
    id: 'yes',
    label: 'Yes',
    description: 'Designate a healthcare agent to make decisions on your behalf',
    name: 'healthcare-agent',
    value: 'yes'
  },
  {
    id: 'no',
    label: 'No',
    description: 'Do not designate a healthcare agent',
    name: 'healthcare-agent',
    value: 'no' 
  }
];

export function NewHDHealthcareAgent() {
  const navigate = useNavigate();
    
  const handleBack = useCallback(() => {
    // Handle back navigation
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../healthcare-agent-details');
  }, [ navigate ]);

  return (
    <div className="new-fa-disposition">
      <ScreenHeader 
        title="Healthcare Agent"
        description="Would you like to designate a healthcare agent to make decisions on your behalf?"
        steps={6}
        step={6}
        handleBack={handleBack}
      />

      <RadioCardOptionGroup options={options} />

      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}